import Vue from "vue";
import { mapGetters } from "vuex";
import { themeHelper }     from "@/components/mixins/themeHelper";
import { faEnvelope, faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default Vue.extend({
    name: "ImageGallery",
    mixins: [themeHelper],
    components: {
        FontAwesomeIcon,
    },
    computed: {
        ...mapGetters(["getContentItem"]),
        haveActualPartImages(){
            var haveActualPartImages = this.successfulImages.length > 0 && 
                this.successfulImages.length === this.numberOfImagesLoaded
                && !( this.successfulImages[0] == "NoImageAvailable" && this.successfulImages.length === 1);
            return haveActualPartImages;
        }
    },
    props: {
        galleryImages: {
            type: Array,
            default: () => [],
        },
        oemPartCode: {
            type: String,
            default: "",
        },
        emailAction: Function,
        printAction: Function,
    },
    data: () => ({
        slide: 0,
        printIcon: faPrint,
        emailIcon: faEnvelope,
        successfulImages: [],
        numberOfImagesLoaded: 0,
        showRequestPicturesSuggestion: false
    }),
    created(){
        this.successfulImages = this.galleryImages;
        this.showRequestPicturesSuggestion = this.successfulImages.length === 1 && this.successfulImages[0] === "NoImageAvailable";
    },
    methods: {
        goToSlide(index: number){
            this.$refs.carousel.setSlide(index);
        },

        goToPrevSlide(){
            this.$refs.carousel.prev();
        },

        goToNextSlide(){
            this.$refs.carousel.next();
        },

        getImageSrc(image: string){
            if(image == "NoImageAvailable"){
                return this.getImage("partNoImageAvailable");
            }
            return image;
        },

        removeImage(index: number){
            this.successfulImages = this.successfulImages.splice( index, 1 );
        },

        emailClicked() {
            this.emailAction();
        },

        printClicked() {
            this.printAction();
        },
    },
});
